import React, { Component } from 'react';
import { connect } from 'react-redux';

import { AppHolder, Toolbar, LogoWrapper, TopbarComponents } from './style';
import appActions from '../../redux/app/actions';
import RSLogo from '../../images/logo.png';

const { toggleCollapsed } = appActions;

class TopBarNoAuth extends Component {
	render() {
		const { customizedTheme } = this.props;
		return (
			<AppHolder style={{ background: customizedTheme.backgroundColor }}>
				<Toolbar
					style={{
						paddingLeft: '30px',
						minHeight: '64px',
						background: customizedTheme.topbarNoAuthTheme,
					}}
				>
					<LogoWrapper>
						<img src={RSLogo} />
					</LogoWrapper>
				</Toolbar>
			</AppHolder>
		);
	}
}

export default connect(
	state => ({
		...state.App,
		locale: state.LanguageSwitcher.language.locale,
		customizedTheme: state.ThemeSwitcher.topbarNoAuthTheme,
	}),
	{ toggleCollapsed }
)(TopBarNoAuth);



// WEBPACK FOOTER //
// ./src/containers/TopbarNoAuth/index.js